import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Lock, ArrowUpRight } from "lucide-react";
import { toast } from "@/components/ui/sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Portal() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("err") === "invalid_or_expired") {
      toast.error("Lien expiré ou invalide. Veuillez redemander un lien.");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Merci d'indiquer votre email.");
      return;
    }
    setLoading(true);
    try {
      await fetch(`${API}/api/portal/request-magic-link`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email }),
      });
      toast.success("Si un accès existe pour cet email, un lien de connexion vous a été envoyé.");
      setEmail("");
    } catch {
      toast.error("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center pt-28 pb-24 px-6" data-testid="portal-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        className="max-w-md w-full text-center"
      >
        <div className="w-16 h-16 mx-auto mb-8 border border-gold flex items-center justify-center">
          <Lock className="text-gold" size={26} strokeWidth={1.5} />
        </div>
        <p className="text-xs uppercase tracking-luxe text-gold mb-4">Espace réservé</p>
        <h1 className="font-serif text-4xl md:text-5xl text-white mb-4">Mon Espace</h1>
        <p className="text-white/50 font-light mb-10">
          L'accès au Cercle est réservé aux membres accompagnés. Renseignez votre email pour recevoir votre lien de connexion sécurisé.
        </p>
        <form onSubmit={handleSubmit} className="space-y-6" data-testid="portal-form">
          <input
            data-testid="portal-email"
            type="email"
            placeholder="Votre email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            className="w-full bg-transparent border-b border-white/20 focus:border-gold rounded-none text-white text-center px-0 py-4 outline-none transition-colors disabled:opacity-60"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="portal-submit"
            className="w-full bg-gold text-brand-ink hover:bg-brand-gold-hover transition-colors px-8 py-4 text-xs uppercase tracking-[0.15em] font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? "Envoi en cours…" : (<>Recevoir mon accès <ArrowUpRight size={16} /></>)}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
